import { SMH } from '@/renderer/scripts/smh';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import shareATM from '@/renderer/scripts/utils/AccessTokenManager/share';
import user, { User } from '@/renderer/scripts/utils/user';
export async function getSpaceAndUserInfo(params?: {
  spaceId?: SMH.SpaceId;
  shareToken?: string;
  spaceOrgId?: number;
}): Promise<User.FlatUserInfo & SMH.GetSpaceInfoData> {
  if (params?.shareToken) {
    const { shareToken } = params;
    const info = await shareATM.get(shareToken);
    const { accessToken, spaceId, userId } = info;
    info.accessToken = accessToken;
    info.spaceId = spaceId;
    info.userId = userId;
    return {
      ...info,
    };
  }
  const userInfo = user.getUserInfo();
  let spaceInfo;
  try {
    spaceInfo = await spaceATM.get(params?.spaceId || '', params?.spaceOrgId);
  } catch (err) {
    spaceInfo = spaceATM.getSync(params?.spaceId || '');
  }
  return {
    ...userInfo,
    ...spaceInfo,
  };
}
